module.exports = __webpack_public_path__ + "img/Group 1946.233fee08.png";